/* eslint-disable */
import React, { useRef } from 'react';
import { Button, Tooltip } from '@patternfly/react-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { ChartCategory } from '../../../helpers/chart-type.registry';
import './CategoryHeader.scss';

interface CategoryHeaderProps {
	category: ChartCategory;
	isExpanded: boolean;
	typeCount: number;
	onToggle: () => void;
}

export const CategoryHeader: React.FC<CategoryHeaderProps> = ({
	category,
	isExpanded,
	typeCount,
	onToggle,
}) => {
	const chipRef = useRef<HTMLButtonElement>(null);

	return (
		<div className="category-header">
			<Button
				ref={chipRef}
				className={`category-chip ${isExpanded ? 'expanded' : 'collapsed'}`}
				onClick={onToggle}
				variant="plain"
			>
				<FontAwesomeIcon
					icon={isExpanded ? faChevronDown : faChevronRight}
					className="chevron"
				/>
				<span className="category-name">{category}</span>
				<span className="type-count">{typeCount}</span>
			</Button>
			<Tooltip
				content={`${isExpanded ? 'Collapse' : 'Expand'} ${category} chart types`}
				reference={chipRef}
			/>
		</div>
	);
};
